import React, { ReactNode, useEffect, useState } from 'react';
import Styled from './AcessoExlusivo.style';
import { Drawer, Tabs, Input, Button, Alert, Table, Switch, Divider, Popconfirm, DatePicker, Select, Collapse } from 'antd';
import { EditOutlined, DeleteOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import CardCategoria from './components/Categoria/CardCategoria';
import { IoAdd, IoReload } from 'react-icons/io5';
import Colors from 'enums/Colors';
import { CategoriaPEService } from 'core/http/service/acessosExclusivos/CategoriaPE.service';
import { ToastError, ToastSuccess } from 'components/Toaster';
import useFetch from 'hooks/useFetch';
import CardCategoriaModel from 'models/acessoExclusivo/CardCategoria';
import RegraPE from 'models/acessoExclusivo/RegraPE';
import { RegrasPEService } from 'core/http/service/acessosExclusivos/RegrasPE.service';
import TokenPE from 'models/acessoExclusivo/TokenPE';
import { TokenPEService } from 'core/http/service/acessosExclusivos/TokenPE.service';
import { TfiReload } from 'react-icons/tfi';
import TokenPE_DTO from 'models/acessoExclusivo/dtos/TokenPE_DTO';
import { RoleList } from 'enums/RoleEnum';
import EstadoDTO from 'models/perfil/EstadoDTO';
import { ProfileService } from 'core/http/service/Profile.service';
import LocalidadeDTO from 'models/perfil/LocalidadeDTO';
import type { PopconfirmProps } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import CategoriaUsersDTO from 'models/acessoExclusivo/dtos/CategoriaUsersDTO';
import { CategoriaUsersPE } from 'core/http/service/acessosExclusivos/CategoriaUsersPE.service';
import moment from 'moment';
import { SearchProps } from 'antd/es/input';
import CategoriaUsersDTO2 from 'models/acessoExclusivo/dtos/CategoriaUsersDTO2';
import TipoEnsinoDTO from 'models/perfil/TipoEnsinoDTO';
import { TipoEnsinoService } from 'core/http/service/TipoEnsino.service';

type TAbas = {
    name: string;
    icon: any;
};

interface IDrawerForm {
    open: boolean;
    handleClose: () => void;

    title: string;
    children?: JSX.Element;
    size?: 'large' | 'default';
}

export const DrawerForm = ({ children, handleClose, open, title, size = 'default' }: IDrawerForm) => {
    return (
        <Drawer size={size} style={{}} title={title} placement={'right'} closable={false} onClose={handleClose} open={open}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                }}
            >
                {children}
            </div>
        </Drawer>
    );
};

interface ICategorias {
    realodAll: number;
    listCategorias: (value: CardCategoriaModel[]) => void;
    tiposEnsino: TipoEnsinoDTO[];
}

const Categorias = ({ realodAll, listCategorias, tiposEnsino }: ICategorias) => {
    const [loading, setLoading] = useState<boolean>(false);
    // const actions: React.ReactNode[] = [<EditOutlined key="edit" />, <SettingOutlined key="setting" />, <EllipsisOutlined key="ellipsis" />];

    const [open, setOpen] = useState(false);
    const [nomeCategoria, setNomeCategoria] = useState<string>('');
    const [reload, setReload] = useState<number>(0);

    const [cardsCategoria, setCardCategorias] = useState<CardCategoriaModel[]>([]);
    const [categoriasFilters, setCategoriasFilters] = useState<CardCategoriaModel[]>([]);

    const serviceCategoria = new CategoriaPEService();

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const handleSubmitCategoria = async () => {
        if (nomeCategoria.length === 0) {
            return ToastError('Campo vazio!');
        }

        setLoading(true);

        const response = await serviceCategoria.inserir(nomeCategoria);

        if (response.status === 201) {
            setReload(reload + 1);
            ToastSuccess('Categoria criada com sucesso!');
            setNomeCategoria('');
            onClose();
        }
        setLoading(false);
    };

    useFetch(async () => {
        setLoading(true);
        const listCardsCategorias = await serviceCategoria.listAll();

        let data: CardCategoriaModel[] = listCardsCategorias.data;

        setCardCategorias(data);
        listCategorias(data);
        setLoading(false);
    }, [reload, realodAll]);

    useEffect(() => {
        setCategoriasFilters(cardsCategoria);
    }, [cardsCategoria]);

    useEffect(() => {
        if (categoriasFilters.length === 0) {
            setReload(reload + 1);
        }
    }, [categoriasFilters]);

    return (
        <>
            <DrawerForm handleClose={onClose} open={open} title="Nova categoria">
                <>
                    <Alert
                        message="Informação"
                        description={
                            'A categoria é um grupo de regras de negócio que armazena os usuários vinculados e define quais soluções terão acesso.'
                        }
                        type="warning"
                    />
                    <Input placeholder={'Categoria'} value={nomeCategoria} onChange={e => setNomeCategoria(e.target.value)} />
                    <Button
                        loading={loading}
                        onClick={() => handleSubmitCategoria()}
                        style={{
                            backgroundColor: Colors.LightGreen,
                            color: Colors.White,
                        }}
                    >
                        {'Criar categoria'}
                    </Button>
                </>
            </DrawerForm>
            <Styled.Content>
                <Styled.Button onClick={showDrawer} style={{ width: 130, marginTop: 10, marginBottom: 10 }}>
                    <IoAdd color={Colors.White} /> Categoria
                </Styled.Button>
                <Select
                    mode="multiple"
                    style={{ minWidth: '200px', height: '40px', marginTop: '10px' }}
                    placeholder="Selecione a categoria"
                    size="large"
                    allowClear
                    onChange={v => setCategoriasFilters(cardsCategoria.filter(card => v.includes(card.nome)))}
                >
                    {cardsCategoria.map((dados, index) => (
                        <Select.Option key={index} value={dados.nome}>
                            {dados.nome}
                        </Select.Option>
                    ))}
                </Select>
            </Styled.Content>
            <Styled.Content>
                {categoriasFilters.map((dados, index) => (
                    <CardCategoria
                        key={index}
                        id={dados.id ?? -1}
                        nome={dados.nome}
                        dadosRegras={dados?.regraPaginaExclusivas ?? []}
                        dadosToken={dados?.tokenPaginaExclusivas ?? []}
                        dadosSolucao={dados?.tipoSolucoes ?? []}
                        dadosTipoEnsino={dados?.tiposEnsino ?? []}
                        tiposEnsinoDisponiveis={tiposEnsino}
                        actions={[]}
                        loading={loading}
                        reloadCategorias={() => setReload(reload + 1)}
                        reloadAll={realodAll}
                    />
                ))}
            </Styled.Content>
        </>
    );
};

interface IRegraPE {
    role: string;
    estado: string;
    municipio: string;
}

const TODOS_MUNICIPIOS = 'Todos Municípios';

const chaveRegra = (regra: Pick<RegraPE, 'role' | 'estado' | 'municipio'>) =>
    JSON.stringify([regra.role, regra.estado, regra.municipio]);

enum FilterType {
    Role = 'role',
    Estado = 'estado',
    Municipio = 'municipio',
}

const Regras = () => {
    const [regras, setRegras] = useState<RegraPE[]>([]);
    const [filterRegras, setFilterRegras] = useState<RegraPE[]>([]);
    const [reload, setReload] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingInfo, setLoadingInfo] = useState<boolean>(false);

    const [cidades, setCidades] = useState<LocalidadeDTO[]>([]);
    const [estados, setEstados] = useState<EstadoDTO[]>([]);
    const [open, setOpen] = useState(false);
    const [roles] = useState(RoleList);

    const [roleFilter, setRoleFilter] = useState<string[]>([]);
    const [cidadesFiltradas, setCidadesFiltradas] = useState<string[]>([]);
    const [estadosFiltrados, setEstadosFiltrados] = useState<string[]>([]);
    const [loteOpen, setLoteOpen] = useState(false);
    const [loteRoles, setLoteRoles] = useState<string[]>([]);
    const [loteEstados, setLoteEstados] = useState<string[]>([]);
    const [loteMunicipios, setLoteMunicipios] = useState<Record<string, string[]>>({});
    const [loteCidadesPorEstado, setLoteCidadesPorEstado] = useState<Record<string, LocalidadeDTO[]>>({});
    const [loteEstadosCarregando, setLoteEstadosCarregando] = useState<string[]>([]);
    const [loteSalvando, setLoteSalvando] = useState(false);

    const profileService = new ProfileService();

    const [regra, setRegra] = useState<IRegraPE>({
        role: '',
        estado: '',
        municipio: '',
    });

    useFetch(async () => {
        const response = await profileService.findAllEstados();

        setEstados(response.data);
    }, []);

    const serviceRegra = new RegrasPEService();

    useFetch(async () => {
        const responses = await serviceRegra.getAll();

        const data: RegraPE[] = responses.data;

        setRegras(data);
        setFilterRegras(data);
        setCidadesFiltradas([]);
        setEstadosFiltrados([]);
        setRoleFilter([]);
    }, [reload]);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
        setRegra({
            role: '',
            estado: '',
            municipio: '',
        });
    };

    const handleSubmitRegra = async () => {
        setLoadingInfo(true);

        let newRegra = new RegraPE();
        newRegra.role = regra.role;
        newRegra.estado = regra.estado;
        newRegra.municipio = regra.municipio;

        if (!(newRegra.role.length > 0 && newRegra.estado.length > 0 && newRegra.municipio.length > 0)) {
            return ToastError('Para criar uma nova regra precisa preencher todos os campos!');
        }

        const response = await serviceRegra.inserir([newRegra]);

        if (response.status === 201) {
            ToastSuccess('Nova regra criada com sucesso!');
            setReload(reload + 1);
            onClose();
        } else {
            ToastError('Ocorreu algum erro ao salvar a nova regra!');
        }

        setLoadingInfo(false);
    };

    const loadCidadesPorUf = async (uf: string) => {
        try {
            setCidades([]);

            const response: any = await profileService.consultarCidadesPorUF(uf);
            let _cidades: LocalidadeDTO[] = response.data.map((item: any) => new LocalidadeDTO().fromJSON(item));

            const cidadeDefault = new LocalidadeDTO();
            cidadeDefault.id = 0;
            cidadeDefault.nome = 'Todos Municípios';

            _cidades.unshift(cidadeDefault);

            setCidades(_cidades);
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    const abrirLote = () => {
        setLoteRoles([]);
        setLoteEstados([]);
        setLoteMunicipios({});
        setLoteCidadesPorEstado({});
        setLoteEstadosCarregando([]);
        setLoteOpen(true);
    };

    const fecharLote = () => {
        setLoteOpen(false);
        setLoteRoles([]);
        setLoteEstados([]);
        setLoteMunicipios({});
        setLoteCidadesPorEstado({});
        setLoteEstadosCarregando([]);
    };

    const handleLoteEstadosChange = async (novosEstados: string[]) => {
        const estadosAdicionados = novosEstados.filter(estado => !loteEstados.includes(estado));
        setLoteEstados(novosEstados);

        setLoteMunicipios(prev => {
            const atualizado = { ...prev };
            Object.keys(atualizado).forEach(estado => {
                if (!novosEstados.includes(estado)) delete atualizado[estado];
            });
            novosEstados.forEach(estado => {
                if (!atualizado[estado]) atualizado[estado] = [];
            });
            return atualizado;
        });
        setLoteCidadesPorEstado(prev => {
            const atualizado = { ...prev };
            Object.keys(atualizado).forEach(estado => {
                if (!novosEstados.includes(estado)) delete atualizado[estado];
            });
            return atualizado;
        });

        if (estadosAdicionados.length === 0) return;

        setLoteEstadosCarregando(prev => [...prev, ...estadosAdicionados]);
        const resultados = await Promise.all(
            estadosAdicionados.map(async estado => {
                try {
                    const response = await profileService.consultarCidadesPorUF(estado);
                    const municipios: LocalidadeDTO[] = response.data.map((item: any) => new LocalidadeDTO().fromJSON(item));
                    const todosMunicipios = new LocalidadeDTO();
                    todosMunicipios.id = 0;
                    todosMunicipios.nome = TODOS_MUNICIPIOS;
                    return { estado, municipios: [todosMunicipios, ...municipios] };
                } catch (error) {
                    console.error(error);
                    return { estado, municipios: null };
                }
            }),
        );

        setLoteCidadesPorEstado(prev => {
            const atualizado = { ...prev };
            resultados.forEach(resultado => {
                if (resultado.municipios) atualizado[resultado.estado] = resultado.municipios;
            });
            return atualizado;
        });
        setLoteEstadosCarregando(prev => prev.filter(estado => !estadosAdicionados.includes(estado)));
        if (resultados.some(resultado => !resultado.municipios)) {
            ToastError('Não foi possível carregar os municípios de um ou mais estados. Remova e selecione novamente o estado para tentar de novo.');
        }
    };

    const regrasLote: RegraPE[] = [];
    let duplicadasExistentes = 0;
    let repetidasNoLote = 0;
    let combinacoesSolicitadas = 0;
    const chavesExistentes = new Set(regras.map(chaveRegra));
    const chavesDoLote = new Set<string>();

    loteRoles.forEach(role => {
        loteEstados.forEach(estado => {
            (loteMunicipios[estado] ?? []).forEach(municipio => {
                combinacoesSolicitadas += 1;
                const regraLote = new RegraPE();
                regraLote.role = role;
                regraLote.estado = estado;
                regraLote.municipio = municipio;
                const chave = chaveRegra(regraLote);

                if (chavesExistentes.has(chave)) {
                    duplicadasExistentes += 1;
                } else if (chavesDoLote.has(chave)) {
                    repetidasNoLote += 1;
                } else {
                    chavesDoLote.add(chave);
                    regrasLote.push(regraLote);
                }
            });
        });
    });

    const loteIncompleto =
        loteRoles.length === 0 ||
        loteEstados.length === 0 ||
        loteEstados.some(estado => (loteMunicipios[estado] ?? []).length === 0) ||
        loteEstadosCarregando.length > 0;

    const salvarLote = async () => {
        if (loteIncompleto) {
            ToastError('Selecione ao menos uma role, um estado e um município para cada estado.');
            return;
        }

        if (regrasLote.length === 0) {
            ToastSuccess('Nenhuma regra nova para criar. Todas as combinações selecionadas já existem ou se repetem no lote.');
            fecharLote();
            return;
        }

        setLoteSalvando(true);
        try {
            const response = await serviceRegra.inserirLote(regrasLote);
            if (response.status === 201) {
                const criadas = response.data.created ?? regrasLote.length;
                const ignoradas = response.data.duplicates ?? 0;
                const duplicatasIgnoradas = duplicadasExistentes + repetidasNoLote + ignoradas;

                ToastSuccess(
                    `Lote processado: ${criadas} regra(s) criada(s) e ${duplicatasIgnoradas} duplicata(s) ignorada(s).`,
                );
                setReload(reload + 1);
                fecharLote();
            } else {
                ToastError('Ocorreu um erro ao salvar as regras do lote.');
            }
        } finally {
            setLoteSalvando(false);
        }
    };

    const handleDelete = async (codigoRegra: number) => {
        const response = await serviceRegra.deleteAll(codigoRegra);

        if (response.status === 200) {
            ToastSuccess('Regra deletada com sucesso!');
            setReload(reload + 1);
        }
    };

    const cancel: PopconfirmProps['onCancel'] = e => {
        console.log(e);
    };

    useEffect(() => {
        let regrasFiltradas = regras;

        if (roleFilter.length > 0) {
            regrasFiltradas = regrasFiltradas.filter(r => roleFilter.includes(r.role));
        }
        if (estadosFiltrados.length > 0) {
            regrasFiltradas = regrasFiltradas.filter(r => estadosFiltrados.includes(r.estado));
        }
        if (cidadesFiltradas.length > 0) {
            regrasFiltradas = regrasFiltradas.filter(r => cidadesFiltradas.includes(r.municipio));
        }

        setFilterRegras(regrasFiltradas);
    }, [estadosFiltrados, cidadesFiltradas, roleFilter]);

    useEffect(() => {
        setFilterRegras(regras);
    }, [regras]);

    // Cria uma lista de estados únicos a partir das regras para evitar duplicados
    const uniqueEstados = Array.from(new Set(regras.map(r => r.estado))).filter(Boolean);

    const uniqueMunicipios = Array.from(new Set(regras.map(r => r.municipio))).filter(Boolean);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <DrawerForm handleClose={fecharLote} open={loteOpen} title="Criar regras em lote" size="large">
                <>
                    <Alert
                        type="info"
                        showIcon
                        message="As combinações serão criadas para cada role selecionada em cada estado e município escolhido."
                        description={`“${TODOS_MUNICIPIOS}” vale somente para o estado selecionado. Combinações já cadastradas ou repetidas serão ignoradas.`}
                    />

                    <Styled.LabelForm>Roles</Styled.LabelForm>
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Selecione uma ou mais roles"
                        value={loteRoles}
                        onChange={setLoteRoles}
                        options={roles.map(role => ({ label: role.label, value: role.value }))}
                    />

                    <Styled.LabelForm>Estados</Styled.LabelForm>
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Selecione um ou mais estados"
                        value={loteEstados}
                        onChange={handleLoteEstadosChange}
                        options={estados.map(estado => ({ label: estado.nome, value: estado.id }))}
                    />

                    {loteEstados.map(estado => (
                        <div key={estado} style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: 12, marginTop: 12 }}>
                            <Styled.LabelForm>
                                Municípios — {estados.find(item => item.id === estado)?.nome ?? estado}
                            </Styled.LabelForm>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder={loteEstadosCarregando.includes(estado) ? 'Carregando municípios...' : 'Selecione municípios'}
                                loading={loteEstadosCarregando.includes(estado)}
                                disabled={!loteCidadesPorEstado[estado]}
                                value={loteMunicipios[estado] ?? []}
                                onChange={value =>
                                    setLoteMunicipios(prev => {
                                        const municipiosAnteriores = prev[estado] ?? [];
                                        if (value.some(municipio => municipio === TODOS_MUNICIPIOS && !municipiosAnteriores.includes(municipio))) {
                                            return { ...prev, [estado]: [TODOS_MUNICIPIOS] };
                                        }
                                        return { ...prev, [estado]: value.filter(municipio => municipio !== TODOS_MUNICIPIOS) };
                                    })
                                }
                                options={(loteCidadesPorEstado[estado] ?? []).map(municipio => ({
                                    label: municipio.nome,
                                    value: municipio.nome,
                                }))}
                            />
                        </div>
                    ))}

                    {loteIncompleto ? (
                        <Alert
                            style={{ marginTop: 16 }}
                            type="warning"
                            showIcon
                            message="Complete as seleções para visualizar as regras que serão criadas."
                        />
                    ) : (
                        <>
                            <Alert
                                style={{ marginTop: 16 }}
                                type="info"
                                showIcon
                                message={`${combinacoesSolicitadas} combinação(ões): ${regrasLote.length} nova(s), ${duplicadasExistentes} já cadastrada(s) e ${repetidasNoLote} repetida(s) no lote.`}
                            />
                            <Table
                                size="small"
                                pagination={{ pageSize: 5 }}
                                scroll={{ y: 240 }}
                                rowKey={(_, index) => String(index)}
                                columns={[
                                    { title: 'Role', dataIndex: 'role', render: (value: string) => roles.find(role => role.value === value)?.label ?? value },
                                    { title: 'Estado', dataIndex: 'estado', render: (value: string) => estados.find(estado => estado.id === value)?.nome ?? value },
                                    { title: 'Município', dataIndex: 'municipio' },
                                ]}
                                dataSource={regrasLote}
                            />
                        </>
                    )}

                    <Button
                        loading={loteSalvando}
                        disabled={loteIncompleto}
                        onClick={salvarLote}
                        style={{ backgroundColor: Colors.LightGreen, color: Colors.White, height: 40, marginTop: 12 }}
                    >
                        Criar regras selecionadas
                    </Button>
                </>
            </DrawerForm>
            <DrawerForm handleClose={onClose} open={open} title="Nova categoria">
                <>
                    <Collapse
                        items={[
                            {
                                key: '1',
                                label: 'Informações Importantes!',
                                children: (
                                    <Alert
                                        message=""
                                        description={
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: `
                       <strong>(Professor) </strong> <br/>
                        (Professor, Estágiario e Auxiliar / Monitor de Classe )<br/>
                        _______________________________<br/>
                       <strong>(Diretor) </strong> <br/>
                        (Diretor(a) e Vice-diretor(a))<br/>
                    _______________________________<br/>
                     <strong> (Técnico de Secretaria / Técnico da Educação) </strong> <br/>
                        (Secretário(a) de educação, Sub-secretário(a) de educação e Técnico(a) de secretaria)<br/>
                    _______________________________<br/>
                     <strong>(Coordenador não parceiro) </strong> <br/>
                        (Coordenador(a) pedagógico, Orientador(a) pedagógico)<br/>
                    `,
                                                }}
                                            />
                                        }
                                        type="warning"
                                    />
                                ),
                            },
                        ]}
                    />

                    <Styled.LabelForm>Role</Styled.LabelForm>
                    <Styled.InputFormSelect
                        value={regra.role}
                        as={'select'}
                        onChange={e => {
                            setRegra({ ...regra, role: e.target.value });
                        }}
                    >
                        <option>Selecione</option>
                        {roles.map((dados, index) => (
                            <option key={index} value={dados.value}>
                                {dados.label}
                            </option>
                        ))}
                    </Styled.InputFormSelect>

                    <Styled.LabelForm>Estado</Styled.LabelForm>
                    <Styled.InputFormSelect
                        value={regra.estado}
                        as={'select'}
                        onChange={e => {
                            setRegra({ ...regra, estado: e.target.value });
                            loadCidadesPorUf(e.target.value);
                        }}
                    >
                        <option>Selecione</option>
                        {estados.map((dados, index) => (
                            <option key={index} value={dados.id}>
                                {dados.nome}
                            </option>
                        ))}
                    </Styled.InputFormSelect>
                    <Styled.LabelForm>Município</Styled.LabelForm>
                    <Styled.InputFormSelect
                        value={regra.municipio}
                        onChange={(e: any) => setRegra({ ...regra, municipio: e.target.value })}
                        as={'select'}
                        disabled={cidades.length === 0}
                    >
                        <option>Selecione</option>
                        {cidades.map((dados, index) => (
                            <option key={index} value={dados.nome}>
                                {dados.nome}
                            </option>
                        ))}
                    </Styled.InputFormSelect>
                    <Button
                        loading={loadingInfo}
                        onClick={() => handleSubmitRegra()}
                        style={{
                            backgroundColor: Colors.LightGreen,
                            color: Colors.White,
                            height: 40,
                            marginTop: '1rem',
                        }}
                    >
                        {'Salvar Regra'}
                    </Button>
                </>
            </DrawerForm>
            <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                <Styled.Button onClick={showDrawer} style={{ width: 130, marginTop: 10, marginBottom: 10 }}>
                    <IoAdd color={Colors.White} /> Nova Regra
                </Styled.Button>
                <Styled.Button onClick={abrirLote} style={{ width: 180, marginTop: 10, marginBottom: 10 }}>
                    <IoAdd color={Colors.White} /> Criar regras em lote
                </Styled.Button>
                <Styled.Button
                    onClick={() => {
                        setReload(reload + 1);
                        ToastSuccess('Informações carregadas com sucesso!');
                    }}
                    style={{ backgroundColor: Colors.PureOrange }}
                >
                    <TfiReload size={24} />
                </Styled.Button>
                <Select
                    mode="multiple"
                    style={{ minWidth: '200px' }}
                    placeholder="Selecione a Role"
                    size="large"
                    value={roleFilter}
                    onChange={value => setRoleFilter(value)}
                >
                    {roles.map((dados, index) => (
                        <Select.Option key={index} value={dados.value}>
                            {dados.label}
                        </Select.Option>
                    ))}
                </Select>
                <Select
                    mode="multiple"
                    style={{ minWidth: '200px' }}
                    placeholder="Selecione  o estado"
                    size="large"
                    value={estadosFiltrados}
                    onChange={value => setEstadosFiltrados(value)}
                >
                    {uniqueEstados.map((estado, index) => (
                        <Select.Option key={index} value={estado}>
                            {estado}
                        </Select.Option>
                    ))}
                </Select>
                <Select
                    mode="multiple"
                    style={{ minWidth: '200px' }}
                    placeholder="Selecione  o município"
                    size="large"
                    onChange={value => setCidadesFiltradas(value)}
                    value={cidadesFiltradas}
                >
                    {uniqueMunicipios.map((municipio, index) => (
                        <Select.Option key={index} value={municipio}>
                            {municipio}
                        </Select.Option>
                    ))}
                </Select>
            </div>

            <Table
                columns={[
                    { title: 'Role', dataIndex: 'role' },
                    { title: 'Estado', dataIndex: 'estado' },
                    { title: 'Município', dataIndex: 'municipio' },
                    { title: 'Ações', dataIndex: 'acoes' },
                ]}
                dataSource={
                    filterRegras.length > 0
                        ? filterRegras.map((d, index) => ({
                              ...d,
                              role: roles.find(rl => rl.value === d.role)?.label || d.role,
                              acoes: (
                                  <>
                                      <Popconfirm
                                          title="Deletar regra"
                                          description={
                                              <p>
                                                  Você realemente deseja deletar está regra? <br />
                                                  Se sim, será removida a regra de todas as categorias relacionada com a mesma.
                                              </p>
                                          }
                                          onConfirm={() => handleDelete(d.id ?? -1)}
                                          onCancel={cancel}
                                          okText="Sim, deletar"
                                          cancelText="Cancelar"
                                      >
                                          <DeleteOutlined key="edit" style={{ cursor: 'pointer' }} />
                                      </Popconfirm>
                                  </>
                              ),
                              key: index,
                          }))
                        : []
                }
                pagination={{ pageSize: 10 }}
            />
        </div>
    );
};

interface IToken {
    setListTokens: (value: TokenPE[]) => void;
}

const Tokens = ({ setListTokens }: IToken) => {
    const [tokens, setTokens] = useState<TokenPE[]>([]);
    const [token, setToken] = useState<string>('');
    const [reload, setReload] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingButton, setLoadingButton] = useState<boolean>(false);

    const [open, setOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [editTokenValue, setEditTokenValue] = useState('');
    const [editTokenId, setEditTokenId] = useState<number | null>(null);

    const serviceToken = new TokenPEService();

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const showEditDrawer = (id: number, value: string) => {
        setEditTokenId(id);
        setEditTokenValue(value);
        setEditOpen(true);
    };

    const onEditClose = () => {
        setEditOpen(false);
        setEditTokenId(null);
        setEditTokenValue('');
    };

    useFetch(async () => {
        const responses = await serviceToken.getAllTokens();
        const data: TokenPE[] = responses.data;

        setTokens(data);
        setListTokens(data);
        setLoading(false);
    }, [reload]);

    const handleUpdate = async (id: number, token: TokenPE_DTO) => {
        const response = await serviceToken.updateToken(id ?? -1, token);

        if (response.status === 200) {
            ToastSuccess('Token atualizado com sucesso!');
            setReload(reload + 1);
            setLoading(true);
        }
    };

    const handleEditSubmit = async () => {
        if (!editTokenValue || editTokenValue.length === 0) {
            return ToastError('Campo vazio!');
        }
        if (editTokenId == null) return;
        setLoadingButton(true);
        const tokenData = TokenPE_DTO.fromJSON({ token: editTokenValue, status: true });
        const response = await serviceToken.updateToken(editTokenId, tokenData);
        if (response.status === 200) {
            ToastSuccess('Token editado com sucesso!');
            setReload(reload + 1);
            onEditClose();
        }
        setLoadingButton(false);
    };

    const handleDelete = async (id: number) => {
        const response = await serviceToken.deleteToken(id);
        if (response.status === 204) {
            ToastSuccess('Token deletado com sucesso!');
            setReload(reload + 1);
        } else {
            ToastError('Erro ao deletar token!');
        }
    };

    function gerarToken(): string {
        const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let token = '';

        for (let i = 0; i < 25; i++) {
            // Adiciona um caractere aleatório
            token += caracteres.charAt(Math.floor(Math.random() * caracteres.length));

            // A cada 5 caracteres, adiciona um '-'
            if ((i + 1) % 5 === 0 && i !== 24) {
                token += '-';
            }
        }

        return token;
    }

    const handleSubmitToken = async (tokenGenerator?: string) => {
        setLoadingButton(true);
        let tokenData = new TokenPE_DTO();

        if (tokenGenerator) {
            tokenData.token = tokenGenerator;
        } else {
            tokenData.token = token;
        }

        if (tokenData.token.length === 0) return ToastError('Campo vazio!');

        tokenData.status = true;

        const response = await serviceToken.inserir(tokenData);

        if (response.status === 201) {
            onClose();
            setReload(reload + 1);
            ToastSuccess('Novo token gerado com sucesso!');

            if (!tokenGenerator) {
                setToken('');
            }
        }
        setLoadingButton(false);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {/* Drawer de novo token */}
            <DrawerForm key={'token'} handleClose={onClose} open={open} title="Novo Token">
                <>
                    <Alert
                        message="Informação"
                        description={'Ao criar um token o mesmo estará disponível para os vínculos nas categorias existentes.'}
                        type="warning"
                    />
                    <Input placeholder={'Token'} value={token} onChange={e => setToken(e.target.value)} />
                    <Button
                        loading={loadingButton}
                        onClick={() => handleSubmitToken()}
                        style={{
                            backgroundColor: Colors.LightGreen,
                            color: Colors.White,
                            height: 40,
                        }}
                    >
                        {'Criar token'}
                    </Button>
                    <Divider />
                    <Button
                        loading={loadingButton}
                        onClick={() => handleSubmitToken(gerarToken())}
                        style={{
                            backgroundColor: Colors.PureOrange,
                            color: Colors.White,
                            height: 40,
                        }}
                    >
                        Gerar um token random
                    </Button>
                </>
            </DrawerForm>

            {/* Drawer para editar token */}
            <DrawerForm key={'edit-token'} handleClose={onEditClose} open={editOpen} title="Editar Token">
                <>
                    <Alert message="Atenção" description={'Edite o valor do token abaixo. O status será mantido como ativo.'} type="info" />
                    <Input placeholder={'Token'} value={editTokenValue} onChange={e => setEditTokenValue(e.target.value)} />
                    <Button
                        loading={loadingButton}
                        onClick={handleEditSubmit}
                        style={{
                            backgroundColor: Colors.LightGreen,
                            color: Colors.White,
                            height: 40,
                        }}
                    >
                        Salvar edição
                    </Button>
                </>
            </DrawerForm>

            <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                <Styled.Button onClick={showDrawer} style={{ width: 130, marginTop: 10, marginBottom: 10 }}>
                    <IoAdd color={Colors.White} /> Novo Token
                </Styled.Button>
                <Styled.Button
                    onClick={() => {
                        setReload(reload + 1);
                        ToastSuccess('Informações carregadas com sucesso!');
                    }}
                    style={{ backgroundColor: Colors.PureOrange }}
                >
                    <TfiReload size={24} />
                </Styled.Button>
            </div>

            <Table
                loading={loading}
                columns={[
                    { title: 'Token', dataIndex: 'token' },
                    { title: 'Status', dataIndex: 'status' },
                    {
                        title: 'Ações',
                        dataIndex: 'acoes',
                        render: (_: any, record: any) => (
                            <div style={{ display: 'flex', gap: 8 }}>
                                <Switch
                                    checked={record.statusRaw}
                                    loading={loading}
                                    onClick={() =>
                                        handleUpdate(record.id ?? -1, TokenPE_DTO.fromJSON({ token: record.token, status: !record.statusRaw }))
                                    }
                                />
                                <EditOutlined
                                    style={{ color: Colors.PureOrange, cursor: 'pointer', fontSize: 18 }}
                                    title="Editar token"
                                    onClick={() => showEditDrawer(record.id, record.token)}
                                />
                                <Popconfirm
                                    title="Deletar token"
                                    description={<p>Você realmente deseja deletar este token?</p>}
                                    onConfirm={() => handleDelete(record.id)}
                                    okText="Sim, deletar"
                                    cancelText="Cancelar"
                                >
                                    <DeleteOutlined style={{ color: Colors.InfoRed, cursor: 'pointer', fontSize: 18 }} title="Excluir token" />
                                </Popconfirm>
                            </div>
                        ),
                    },
                ]}
                dataSource={tokens.map((d, index) => ({
                    ...d,
                    statusRaw: d.status,
                    status: d.status ? (
                        <span
                            style={{
                                backgroundColor: Colors.LightGreen,
                                color: Colors.White,
                                padding: 5,
                                borderRadius: 10,
                            }}
                        >
                            Ativo
                        </span>
                    ) : (
                        <span
                            style={{
                                backgroundColor: Colors.InfoRed,
                                color: Colors.White,
                                padding: 5,
                                borderRadius: 10,
                            }}
                        >
                            Inativo
                        </span>
                    ),
                    key: index,
                }))}
                pagination={{ pageSize: 10 }}
            />
        </div>
    );
};

const { RangePicker } = DatePicker;

type TSelected = {
    value: string;
    label: string;
};

interface IIFilter {
    filterCategoria: TSelected;
    filterToken: TSelected;
    filterEmail: string;
}

interface IUsers {
    listCategorias: CardCategoriaModel[];
    listTokens: TokenPE[];
}

const Users = ({ listCategorias, listTokens }: IUsers) => {
    const [users, setUsers] = useState<CategoriaUsersDTO[]>([]);
    const [reload, setReload] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [dateRange, setDateRange] = useState<string[]>([]);
    const [filteredUsers, setFilteredUsers] = useState<CategoriaUsersDTO[]>([]);

    const [searchCategoria, setSearchCategoria] = useState('Categoria');
    const [searchToken, setSearchToken] = useState('Token');
    const [searchEmail, setSearchEmail] = useState('');

    const [filter, setFilter] = useState<IIFilter>({
        filterCategoria: { value: '', label: '' },
        filterToken: { value: '', label: '' },
        filterEmail: '',
    });

    const serviceCategoriaUsers = new CategoriaUsersPE();

    const mapUserRolesToLabels = (users: CategoriaUsersDTO2[]): CategoriaUsersDTO2[] => {
        return users.map(user => {
            // Encontrar o item correspondente na RoleList
            const roleItem = RoleList.find(role => role.value === user.role);

            // Criar uma nova instância de CategoriaUsersDTO2
            const newUser = new CategoriaUsersDTO2();
            newUser.email = user.email;
            newUser.estado = user.estado;
            newUser.cidade = user.cidade;
            newUser.role = roleItem ? roleItem.label : user.role; // Substitui o role pelo label correspondente
            newUser.categoria = user.categoria;
            newUser.token = user.token;
            newUser.ultimaAtualizacao = user.ultimaAtualizacao;

            return newUser;
        });
    };

    useFetch(async () => {
        const responses = await serviceCategoriaUsers.listAll();
        const data: CategoriaUsersDTO[] = responses.data;

        // Mapeando os roles para labels
        const usersWithLabels = mapUserRolesToLabels(data);

        setUsers(usersWithLabels);
        setLoading(false);
    }, [reload]);

    const onSearchCategoria: SearchProps['onSearch'] = (value, _e, info) => {
        setFilter({ ...filter, filterCategoria: { value: value, label: value } });
        setSearchCategoria(value);
    };

    const onSearchToken: SearchProps['onSearch'] = (value, _e, info) => {
        setFilter({ ...filter, filterToken: { value: value, label: value } });
        setSearchToken(value);
    };

    const onSearchEmail = (value: string) => {
        setSearchEmail(value);

        setFilter(prev => ({
            ...prev,
            filterEmail: value,
        }));
    };

    const handleRangePickerChange = (dates: any, dateStrings: any) => {
        if (!dates) {
            setDateRange([]);
        } else {
            setDateRange(dateStrings);
        }
    };

    const handleDownloadXLS = () => {
        const selectedUsers = filteredUsers;

        if (selectedUsers.length === 0) return ToastError('Lista vazia para gerar o XLS');

        // Mapeia os usuários para um formato adequado para o Excel
        const xlsData = selectedUsers.map(user => [
            user.email,
            user.role,
            user.estado,
            user.cidade,
            user.categoria,
            user.token,
            moment(user.ultimaAtualizacao).format('DD/MM/YYYY HH:mm:ss'),
        ]);

        // Cria o conteúdo do arquivo XLS
        const xlsContent = [['Email', 'Role', 'Estado', 'Municipio', 'Categoria', 'Token', 'Data'], ...xlsData]
            .map(row => row.join('\t')) // Usa tabulação como delimitador para XLS
            .join('\n');

        // Cria um Blob a partir do conteúdo
        const blob = new Blob([xlsContent], { type: 'application/vnd.ms-excel;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `relatorio-${new Date().getMilliseconds()}-${new Date().getSeconds()}.xls`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const applyFilters = (users: CategoriaUsersDTO[], filter: IIFilter) => {
        if (!filter) {
            return users;
        }

        return users.filter(user => {
            const matchCategoria = user.categoria.toLowerCase().includes(filter.filterCategoria.value.toLowerCase());
            const matchToken = user.token.toLowerCase().includes(filter.filterToken.value.toLowerCase());
            const matchEmail = user.email.toLowerCase().includes(filter.filterEmail.toLowerCase());

            let matchDate = true;

            if (dateRange.length > 0) {
                const formattedStartDate = moment(dateRange[0], 'DD-MM-YYYY').startOf('day');
                const formattedEndDate = moment(dateRange[1], 'DD-MM-YYYY').endOf('day');
                const userDate = moment(user.ultimaAtualizacao);

                matchDate = userDate.isSameOrAfter(formattedStartDate) && userDate.isSameOrBefore(formattedEndDate);
            }

            return matchCategoria && matchToken && matchEmail && matchDate;
        });
    };

    const resetFilter = () => {
        setFilter({ filterCategoria: { value: '', label: '' }, filterToken: { value: '', label: '' }, filterEmail: '' });
        setDateRange([]);
        setFilteredUsers(users);
        setSearchCategoria('Categoria');
        setSearchToken('Token');
        setSearchEmail('');
    };

    useEffect(() => {
        setFilteredUsers(applyFilters(users, filter));
    }, [filter, users, dateRange]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                <Styled.Button onClick={handleDownloadXLS} style={{ width: 130, marginTop: 10, marginBottom: 10 }}>
                    Gerar XLS
                </Styled.Button>
                <Styled.Button
                    onClick={() => {
                        setReload(reload + 1);
                        ToastSuccess('Informações carregadas com sucesso!');
                    }}
                    style={{ backgroundColor: Colors.PureOrange }}
                >
                    <TfiReload size={24} />
                </Styled.Button>
            </div>

            <div
                style={{
                    display: 'flex',
                    marginBottom: 10,
                    gap: '2rem',
                }}
            >
                <RangePicker placeholder={['Início', 'Fim']} format={'DD-MM-YYYY'} onChange={handleRangePickerChange} />
                <Select
                    style={{ width: 120 }}
                    placeholder="Categorias"
                    onChange={value => onSearchCategoria(value)}
                    value={searchCategoria}
                    options={listCategorias.map(dados => ({
                        label: dados.nome,
                        value: dados.nome,
                    }))}
                />
                <Select
                    style={{ width: 120 }}
                    placeholder="Tokens"
                    onChange={value => onSearchToken(value)}
                    value={searchToken}
                    defaultActiveFirstOption
                    options={listTokens.map(dados => ({
                        label: dados.token,
                        value: dados.token,
                    }))}
                />
                <Input
                    style={{ width: 250 }}
                    placeholder="E-mail"
                    allowClear
                    value={searchEmail}
                    onChange={e => onSearchEmail(e.target.value)}
                />
                <Styled.ButtonFilterReset onClick={resetFilter}>
                    <IoReload />
                    <p>Limpar Filtros</p>
                </Styled.ButtonFilterReset>
            </div>
            <Table
                loading={loading}
                columns={[
                    { title: 'E-mail', dataIndex: 'email' },
                    { title: 'Role', dataIndex: 'role' },
                    { title: 'Estado', dataIndex: 'estado' },
                    { title: 'Município', dataIndex: 'cidade' },
                    { title: 'Categoria', dataIndex: 'categoria' },
                    { title: 'Token', dataIndex: 'token' },
                    { title: 'Data', dataIndex: 'data' },
                ]}
                dataSource={filteredUsers.map((d, index) => ({
                    ...d,
                    data: moment(d.ultimaAtualizacao).format('DD/MM/YYYY HH:mm:ss'),
                    key: index,
                }))}
                pagination={{ pageSize: 10 }}
            />
        </div>
    );
};

const Abas: TAbas[] = [
    {
        name: 'Categorias',
        icon: null,
    },
    {
        name: 'Regras',
        icon: null,
    },
    {
        name: 'Tokens',
        icon: null,
    },
    {
        name: 'Usuários',
        icon: null,
    },
];

const CODIGO_TIPO_ENSINO_EXCLUIDO = 99;

const AcessoExclusivo = () => {
    const [abaAcitveAll, setAbaActiveAll] = useState<number>(1);
    const [reloadAll, setReloadAll] = useState<number>(1);
    const [listCategorias, setListCategorias] = useState<CardCategoriaModel[]>([]);
    const [listTokens, setListTokens] = useState<TokenPE[]>([]);
    const [listTiposEnsino, setListTiposEnsino] = useState<TipoEnsinoDTO[]>([]);

    const tipoEnsinoService = new TipoEnsinoService();

    useFetch(() => {
        if (abaAcitveAll) setReloadAll(reloadAll + 1);
    }, [abaAcitveAll]);

    useFetch(async () => {
        const response = await tipoEnsinoService.getAll();

        const dados: TipoEnsinoDTO[] = response.data;

        setListTiposEnsino(dados.filter(item => item.id !== CODIGO_TIPO_ENSINO_EXCLUIDO));
    }, []);

    return (
        <Styled.Container>
            <Styled.H1>{`Gestão dos Acessos Exclusivos`.toLocaleUpperCase()}</Styled.H1>
            <Tabs
                defaultActiveKey="1"
                activeKey={abaAcitveAll.toString()}
                onChange={e => setAbaActiveAll(parseInt(e))}
                items={Abas.map((dados, i) => {
                    const id = String(i + 1);
                    return {
                        key: id,
                        label: dados.name,
                        children:
                            parseInt(id) === 1
                                ? Categorias({
                                      realodAll: reloadAll,
                                      listCategorias(value) {
                                          setListCategorias(value);
                                      },
                                      tiposEnsino: listTiposEnsino,
                                  })
                                : parseInt(id) === 2
                                ? Regras()
                                : parseInt(id) === 3
                                ? Tokens({
                                      setListTokens(value) {
                                          setListTokens(value);
                                      },
                                  })
                                : Users({ listCategorias: listCategorias, listTokens: listTokens }),
                        icon: dados.icon,
                    };
                })}
            />
        </Styled.Container>
    );
};

export default AcessoExclusivo;
